// Affiliate-eligible tools for the Funding Readiness Worksheet.
// All URLs are PLACEHOLDERS — replace with your real affiliate links when ready.

export const FUNDING_TOOLS = [
  {
    id: "northwest",
    name: "Northwest Registered Agent",
    category: "Foundation",
    tiers: ["foundation"],
    blurb: "Form your LLC and act as your registered agent — fast, simple, private.",
    cta: "Form Your LLC",
    url: "https://www.northwestregisteredagent.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "legalzoom",
    name: "LegalZoom",
    category: "Foundation",
    tiers: ["foundation"],
    blurb: "LLC, EIN, operating agreement, and compliance — all in one place.",
    cta: "Start Your Business",
    url: "https://www.legalzoom.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "dnb",
    name: "Dun & Bradstreet",
    category: "Credit Profile",
    tiers: ["foundation", "building"],
    blurb: "Get your D-U-N-S Number — required for nearly all business credit reporting.",
    cta: "Get Your D-U-N-S",
    url: "https://www.dnb.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "nav",
    name: "Nav",
    category: "Credit Monitoring",
    tiers: ["building", "ready"],
    blurb: "Monitor your business credit across D&B, Experian & Equifax. Match to lender offers.",
    cta: "Monitor My Credit",
    url: "https://nav.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "tillful",
    name: "Tillful",
    category: "Credit Monitoring",
    tiers: ["building"],
    blurb: "Free business credit score monitoring + credit-building card option.",
    cta: "Check My Score",
    url: "https://tillful.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "creditsuite",
    name: "Credit Suite",
    category: "Credit Building",
    tiers: ["building", "ready"],
    blurb: "Step-by-step business credit building program with vendor & lender connections.",
    cta: "Build My Credit",
    url: "https://creditsuite.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "lendio",
    name: "Lendio",
    category: "Funding Marketplace",
    tiers: ["ready", "funded"],
    blurb: "One application, 75+ lenders. Compare term loans, LOCs, SBA, and more.",
    cta: "Compare Loan Offers",
    url: "https://www.lendio.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "fundera",
    name: "Fundera by NerdWallet",
    category: "Funding Marketplace",
    tiers: ["ready", "funded"],
    blurb: "Side-by-side comparison of business loans and credit cards.",
    cta: "Browse Offers",
    url: "https://www.fundera.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "brex",
    name: "Brex",
    category: "Business Credit Card",
    tiers: ["funded"],
    blurb: "High-limit corporate card with no personal guarantee. Built for funded businesses.",
    cta: "Apply Now",
    url: "https://www.brex.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "ramp",
    name: "Ramp",
    category: "Business Credit Card",
    tiers: ["ready", "funded"],
    blurb: "Corporate card + expense automation. Built-in spend controls.",
    cta: "Apply Now",
    url: "https://ramp.com/?aff=YOUR_AFFILIATE_ID",
  },
  {
    id: "divvy",
    name: "BILL Spend & Expense (Divvy)",
    category: "Business Credit Card",
    tiers: ["building", "ready"],
    blurb: "Business credit card + free expense management. Lower approval bar than Brex.",
    cta: "Apply Now",
    url: "https://www.bill.com/product/spend-expense?aff=YOUR_AFFILIATE_ID",
  },
];

export const TIER_LABELS = {
  foundation: "Pre-Foundation",
  building: "Building Credit",
  ready: "Ready to Apply",
  funded: "Funding-Ready",
};

export function getToolsForTier(tierSlug) {
  return FUNDING_TOOLS.filter((t) => t.tiers.includes(tierSlug));
}
